/**
 * Source of the identity verification decision
 * Indicates how and why a particular identity verification decision was made
 */
export enum DecisionSource {
    AutoByRegistration = 'auto-registration',
    AutoByName = 'auto-name',
    ManualSelection = 'manual-selection',
    ManualConfirmation = 'manual-confirmation',

    /** @deprecated Use more specific sources. Kept for backwards compatibility */
    Auto = 'auto',
    /** @deprecated Use ManualSelection or ManualConfirmation. Kept for backwards compatibility */
    Manual = 'manual',
}
